import Env from "../base/env.js";
import Channels from "../base/channels.js";
import "scroll-restoration-polyfill";
import MainnavTouch from "../ui/mainnav-touch.js";
import UISwitcher from "../ui/UIswitcher";
import Launcher from "../components/launcher/Launcher";
import RegisterMail from "../components/RegisterMail";
import PopinAlert from "../components/PopinAlert";
import SearchPopin from "../components/SearchPopin";
import lozad from "lozad";

class UI {
  constructor() {
    history.scrollRestoration = "manual";
    // this.detectEmbedMode()
    this.resetEnv();
    this.launcher = new Launcher();
    Env.framework.mainnav = new MainnavTouch();
    this.popinAlert = new PopinAlert();
    this.moodletterPopin = new RegisterMail(
      document.querySelector(".jsRegister--popin")
    );
    this.moodletter = new RegisterMail(
      document.querySelector(".jsRegister--footerv2")
    );
    this.uiSwitch = new UISwitcher();
    this.SearchPopin = new SearchPopin();
    this.updateMainnavActive({
      url: window.location.href,
      namespace: Env.framework.toolbox.getController(),
    });
    if (this.embedMode == 0) {
      this.listenTransitionUpdateBg(Env.$mainNav);
      this.listenTransitionUpdateBg(Env.$master.querySelector(".main-header"));
    }
    if (this.embedMode == 1) {
      Env.$html.classList.add("isEmbed");
    }
    setTimeout(() => {
      this.popinAlert.alert();
    }, 5000);
    this.footerBG();
    setTimeout(() => {
      this.cookieForcing();
    }, 1000);

    if (Env.mobileCSS) {
      setTimeout(() => {
        new Accordion(".accordion-container", {
          duration: 400,
          showMultiple: true,
        });
      }, 100);
    }
    this.fnMouseOut = this.detectMouseOut.bind(this);
    // this.alertLeaving()
  }

  detectMouseOut(e) {
    const shouldShowExitIntent =
      !e.toElement && !e.relatedTarget && e.clientY < 10;
    if (shouldShowExitIntent) {
      document.removeEventListener("mouseout", this.fnMouseOut);
      this.popinAlert.open();
    }
  }

  alertLeaving() {
    setTimeout(() => {
      document.addEventListener("mouseout", this.fnMouseOut);
    }, 5000);
  }

  allowHashLinks() {
    Env.allowHashlinksInBarba = true;
  }

  detectEmbedMode() {
    const url = window.location.href;
    const urlOjb = new URL(url);
    this.embedMode = urlOjb.searchParams.get("embed") * 1;
  }

  disableHashLinks() {
    Env.allowHashlinksInBarba = false;
  }

  footerBG() {
    const $colors = [
      "#F9C4B7",
      "#B56815",
      "#809B51",
      "#421C2F",
      "#3A2B47",
      "#174F87",
      "#AF3E1C",
      "#59829C",
      "#E9B479",
      "#D6C490",
      "#5B2F12",
      "#225B22",
      "#8AAACE",
      "#E59E00",
    ];
    const getRandom = $colors[Math.floor(Math.random() * $colors.length)];
    console.log(getRandom);
    const $receptors = document.querySelectorAll(".jsRandomColor--receptor");
    for (let $receptor of $receptors) {
      if ($receptor.classList.contains("bandletter") == true) {
        $receptor.style.backgroundColor = getRandom;
        // $receptor.querySelector('.h3').style.color = getRandom
        // $receptor.querySelector('.description').style.color = getRandom
        // $receptor.querySelector('.newsletter-component__form').style.backgroundColor = getRandom
      } else {
        $receptor.style.backgroundColor = getRandom;
      }
    }
  }

  listenTransitionUpdateBg(view) {
    const $hovers = view.querySelectorAll(
      ".jsUpdateTransition--trigger:not(.jsUpdateTransition--listened)"
    );
    for (let i = 0; i < $hovers.length; i++) {
      const $hover = $hovers[i];
      $hover.addEventListener("click", () => {
        const getBg = $hover.getAttribute("data-bg");
        Env.$mainTransition.style.backgroundColor = getBg;
      });
      $hover.classList.add("jsUpdateTransition--listened");
    }
  }

  lazy() {
    const observer = lozad(); // lazy loads elements with default selector as '.lozad'
    observer.observe();
  }

  listenPopinTrigger(view) {
    const $triggers = view.querySelectorAll(".jsTrigger--popin");
    for (let i = 0; i < $triggers.length; i++) {
      const $trigger = $triggers[i];
      $trigger.addEventListener("click", () => {
        Env.popinModeClicked = true;
      });
    }
  }

  resetEnv() {
    Channels.on("statechange::before", function () {});
    Channels.on("statechange::ready", (current, old, container) => {
      Env.$html.classList.remove("popin--isDark");
      Env.$html.classList.remove("cover--good");
      Env.$html.classList.remove("cover--moodboard");
      Env.$html.classList.remove("skin--isWhite");
      Env.$html.classList.remove("skin--isDark");
      Env.$html.classList.remove("skin--forceDark");
      this.updateMainnavActive(current);
      // if(Env.navActions == Env.navActionsMax) {
      //     this.popinAlert.alert()
      // } else {
      //     Env.navActions++
      // }
    });
    Channels.on("statechange::finalize", function () {
      Env.popinModeClicked = false;
    });
  }

  cookieForcing() {
    const $title = document.querySelector(".cc-nb-title");
    if ($title != null) {
      $title.innerHTML = config.txtCookie;
    }

    const $cta = document.querySelector(".cc-nb-okagree");
    if ($cta != null) {
      $cta.innerHTML = config.ctaCookie;
    }

    setTimeout(() => {
      Env.$html.classList.add("show-cookie");
    }, 1000);
  }

  pinRefresh() {
    if (Env.isVisiting) {
      setTimeout(() => {
        PinUtils.build();
      }, 200);
    }
  }

  trackerPopinProduct() {
    gtag("event", "view_item", {
      event_category: "engagement",
      non_interaction: false,
    });
  }

  updateMainnavActive(context) {
    if (window.location.hash.length > 0) {
      context.url = window.location.href.split("#")[0];
    }
    for (let item of Env.$menuListeners) {
      const href = item.getAttribute("href");
      if (href == context.url) {
        item.parentElement.classList.add("is--active");
      } else {
        item.parentElement.classList.remove("is--active");
      }
    }
  }
}

export default UI;
